<template>
  <v-select
    :value="value"
    :items="courses"
    item-text="name"
    item-value="id"
    label="自動延長コース"
    :hint="hint"
    :disabled="!clubAutoExtensionEnabled"
    persistent-hint
    clearable
    dense
    @input="$emit('input', $event)"
  />
</template>

<script>
import { computed } from '@vue/composition-api'
import { useClubAutoExtensionEnabled } from '@/views/composable/useAutoExtensionCountdown'

// 席種（ホール）ごとの自動延長コース。店舗設定の自動延長がOFFのときは
// サーバーがこの値を受け取っても無視するため、設定させずに理由をヒントで示す。
export default {
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    courses: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const clubAutoExtensionEnabled = useClubAutoExtensionEnabled()

    const hint = computed(() => (clubAutoExtensionEnabled.value
      ? 'この席種で自動延長するときに使う延長コース（未選択なら店舗設定に従います）'
      : '店舗設定の自動延長を有効にすると設定できます'))

    return { clubAutoExtensionEnabled, hint }
  },
}
</script>
